// SAJAFO — prev/next arrows on the main product photo cycle through every media item.
// Dawn's own slider-button click handler moves the gallery by scrolling its list
// horizontally, but the non-active slide is display:none for our single-photo layout,
// so there's nothing left to scroll to. This swaps the .is-active class directly instead.
(function () {
  function initGalleryNav(wrapper) {
    var items = Array.prototype.slice.call(wrapper.querySelectorAll('.product__media-item'));
    if (items.length < 2) return;

    var prevBtn = wrapper.querySelector('.slider-buttons .slider-button--prev');
    var nextBtn = wrapper.querySelector('.slider-buttons .slider-button--next');
    if (!prevBtn || !nextBtn) return;

    function activeIndex() {
      for (var i = 0; i < items.length; i++) {
        if (items[i].classList.contains('is-active')) return i;
      }
      return 0;
    }

    function goTo(index) {
      var wrapped = (index + items.length) % items.length;
      items.forEach(function (item, i) {
        item.classList.toggle('is-active', i === wrapped);
      });
    }

    function onClick(step) {
      return function (event) {
        event.preventDefault();
        event.stopImmediatePropagation();
        goTo(activeIndex() + step);
      };
    }

    prevBtn.addEventListener('click', onClick(-1), true);
    nextBtn.addEventListener('click', onClick(1), true);
  }

  document.querySelectorAll('.product__media-wrapper').forEach(initGalleryNav);
})();
